import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import styles from './Legend.module.scss'

const Legend = ({ data }) => (
  <div className={styles.legend}>
    <ul className={styles.legendList}>
      {data.map((datapoint, index) => (
        <li className={styles.row} key={index}>
          <span
            className={classnames(
              styles.bullet,
              !datapoint.value && styles.emptyBullet
            )}
            style={{ backgroundColor: datapoint.color }}
          />
          <p className={styles.title}>{datapoint.title}</p>
          <p className={styles.subtitle}>{datapoint.subtitle}</p>
          <p className={styles.formattedValue}>
            {datapoint.formattedValue || datapoint.value || '?'}
          </p>
        </li>
      ))}
    </ul>
  </div>
)

Legend.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
      formattedValue: PropTypes.string,
      value: PropTypes.number,
      color: PropTypes.string,
    })
  ),
}

export default Legend
